/* 
    Importing Dependencies
*/
import * as service from "../../Service/Service";

export default {
  name: "FileUpload",
  data: () => ({
    imageUrl: "",
    imageName: "",
    topic: "",
    snackbar: {
      isActive: false,
      text: "",
      color: "",
      timeout: 2000
    },
    isLoading: false
  }),

  methods: {
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },

    pickFile() {
      this.$refs.image.click();
    },

    async upload() {
      if (this.imageName == "") {
        this.snackbar.isActive = true;
        this.snackbar.text = "Please select an excel";
        this.snackbar.color = "warning";
        return false;
      }

      let context = this;
      let formData = new FormData();
      formData.append("file", this.imageFile);
      this.isLoading = true;
      let result = await service.UploadExcel(formData);

      if (!result.error) {
        this.snackbar.isActive = true;
        this.snackbar.text = "Excel uploaded successfully";
        this.snackbar.color = "success";
        this.imageName = "";
        this.$refs.image.value = "";
      } else {
        this.snackbar.isActive = true;
        this.snackbar.text = "Excel upload failed";
        this.snackbar.color = "warning";
        this.imageName = "";
        this.$refs.image.value = "";
      }
      this.isLoading = false;
    }
  }
};
